export enum EventType {
  ACQUIRE_TOKEN_INIT = 'pulse:acquire-token-init',
  ACQUIRE_TOKEN_SUCCESS = 'pulse:acquire-token-success',
  ACQUIRE_TOKEN_FAILURE = 'pulse:acquire-token-failure',
  USER_LOGOUT = 'pulse:user-logout',
  LOGIN_FAILURE = 'pulse:login-failure',
  LOGIN_SUCCESS = 'pulse:login-success',
}

export interface IAuthEvent {
  type: EventType;
  payload?: unknown;
}
